// ▼ 追加：ハッシュから「セクションのトップ」までスクロールする関数
function scrollToHashSection(hash) {
  // hash は "panel-template--..." というID文字列を想定
  const targetPanel = document.getElementById(hash);
  if (!targetPanel) return;

  // パネルが属しているセクション（なければ product-list、最後の保険でパネル自身）
  const section =
    targetPanel.closest('.shopify-section') ||
    targetPanel.closest('.product-list') ||
    targetPanel;

    // 固定ヘッダーがある前提で、その高さぶんだけオフセット
  const header =
    document.querySelector('header.header, .shopify-section-header, .site-header');
  const headerHeight = header ? header.offsetHeight : 0;

  // SP：20px、PC：60px 上に余白をとるイメージ
  const isMobile = window.matchMedia('(max-width: 999px)').matches;
  const extraOffset = isMobile ? 60 : 45; 

  const y = section.getBoundingClientRect().top + window.scrollY - headerHeight - extraOffset;

  window.scrollTo({
    top: y,
    behavior: 'smooth' 
  });
}

function activateTabFromHash() {
  const rawHash = window.location.hash;
  if (!rawHash || rawHash === '#') return;

  const hash = decodeURIComponent(rawHash).replace('#', '');

  // aria-controls（パネルID）またはボタンIDに一致するタブを探す
  const tabButton =
    document.querySelector(`.tabs-nav__item[aria-controls="${hash}"]`) ||
    document.querySelector(`.tabs-nav__item#${hash}`);

  if (tabButton) {
    // タブが非表示でも確実にクリックイベントを起こす
    requestAnimationFrame(() => {
      tabButton.dispatchEvent(new Event('click', { bubbles: true }));

      // ★ ここで scrollIntoView は使わず、自前のスクロール処理に変更
      setTimeout(() => {
        scrollToHashSection(hash);
      }, 200); // タブの内容が切り替わるのを少し待ってからスクロール
    });
  } else {
    // 対象のタブがまだDOMに描画されていない場合、再試行
    setTimeout(activateTabFromHash, 300);
  }
}

// 初回読み込み時：非同期描画に備えて遅延実行
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(activateTabFromHash, 800);
});

// ハッシュが変更されたときも対応する
window.addEventListener('hashchange', activateTabFromHash);
